export default "__VITE_ASSET__BLJrbcQs__"